var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vue-slider',{ref:"slider",attrs:{"show":_vm.show,"dot-size":10,"height":165,"width":10,"direction":'vertical',"tooltip":'always'},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }